angular.module 'bookAndPay', [
  'gym.components',
  'ui.router',
  'ui.bootstrap',
  'infinite-scroll',
  'shared',
  'restangular',
  'shared',
  'filters',
  'tandibar/ng-rollbar',
  'angular-flash.service',
  'angular-flash.flash-alert-directive',
  'react'
]
  .run (Restangular, restangularInterceptors, $rootScope, $window) ->
    Restangular
      .addRequestInterceptor restangularInterceptors.RequestInterceptor
      .addResponseInterceptor restangularInterceptors.ResponseInterceptor

    $rootScope.$on '$stateChangeStart', (event, toState, toParams) ->
      confirmMessage = $rootScope.stateChangeConfirmMessage
      if confirmMessage && !$window.confirm(confirmMessage)
        event.preventDefault()
        return
      else
        $rootScope.stateChangeConfirmMessage = undefined
        $window.onbeforeunload = undefined

    $rootScope.$on '$stateChangeError', ->
      console.error arguments[5]

  .config (
    $locationProvider,
    $stateProvider,
    $httpProvider,
    RestangularProvider,
    RollbarProvider
  ) ->
    meta = angular.element(document.querySelectorAll('meta[name=csrf-token]'))
    $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-Token'
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    $locationProvider.html5Mode(true)
    RollbarProvider.init window._rollbarConfig
    RestangularProvider.setBaseUrl("/websites/#{window.DATA.domain}/book_and_pay")

    $stateProvider
      .state 'bookAndPay',
        url: '/websites/:domain/book_and_pay',
        abstract: true,
        template: '<ui-view>'

      .state 'bookAndPay.newCart',
        url: '/offers/:uuid/carts/new?ct&ce&eid&flash'
        controller: 'NewCartCtrl'
        template: require('templates/book_and_pay/new_cart.html.slim')
        resolve:
          newCart: ($stateParams, Restangular, $q) ->
            Restangular.one('offers', $stateParams.uuid).one('carts', 'new').get(ct: $stateParams.ct).then (response) ->
              response
            , (response) ->
              if response.data.redirect_url
                window.location.href = response.data.redirect_url
              $q.reject()

      .state 'bookAndPay.editCart',
        url: '/carts/:uuid'
        controller: 'EditCartCtrl'
        template: require('templates/book_and_pay/edit_cart.html.slim')
        resolve:
          cart: ($stateParams, Restangular, $q) ->
            Restangular.configuration.getIdFromElem = (elem) ->
              elem['cart_uuid'] || elem['id']
            Restangular.one('carts', $stateParams.uuid).get().then (response) ->
              response
            , (response) ->
              if response.data.redirect_url
                window.location.href = response.data.redirect_url
              $q.reject()

      .state 'bookAndPay.showEvents',
        url: '/carts/:uuid/events'
        controller: 'ShowEventsCtrl'
        template: require('templates/book_and_pay/show_events.html.slim')
        resolve:
          cart: ($stateParams, Restangular, $q) ->
            Restangular.configuration.getIdFromElem = (elem) ->
              elem['cart_uuid'] || elem['id']
            Restangular.one('carts', $stateParams.uuid).get().then (response) ->
              response
            , (response) ->
              if response.data.redirect_url
                window.location.href = response.data.redirect_url
              $q.reject()
          events: ($stateParams, Restangular, $q) ->
            Restangular.one('carts', $stateParams.uuid).all('events').getList().then (response) ->
              response
            , (response) ->
              if response.data.redirect_url
                window.location.href = response.data.redirect_url
                $q.reject()
              else
                response.data
      .state 'bookAndPay.processPayment',
        url: '/carts/:uuid/process_payment'
        controller: 'ProcessPaymentCtrl'
        template: require('templates/book_and_pay/process_payment.html.slim')
        resolve:
          cart: ($stateParams, Restangular, $q) ->
            Restangular.one('carts', $stateParams.uuid).customGET('process_payment').then (response) ->
              response
            , (response) ->
              if response.data.redirect_url
                window.location.href = response.data.redirect_url
              $q.reject()

      .state 'bookAndPay.complete',
        url: '/carts/:uuid/complete'
        controller: 'CompleteCtrl'
        template: require('templates/book_and_pay/complete.html.slim')
        resolve:
          cart: ($stateParams, Restangular, $q) ->
            Restangular.one('carts', $stateParams.uuid).customGET('complete').then (response) ->
              response
            , (response) ->
              if response.data.redirect_url
                window.location.href = response.data.redirect_url
              $q.reject()

      .state 'bookAndPay.sampleComplete',
        url: '/offers/:uuid/carts/sample_complete?ct'
        controller: 'SampleCompleteCtrl'
        template: require('templates/book_and_pay/complete.html.slim')
        resolve:
          cart: ($stateParams, Restangular) ->
            Restangular
              .one('offers', $stateParams.uuid).one('carts', 'sample_complete').get(ct: $stateParams.ct)
